// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ih-0";
export var leftAlign = "_ih-4";
export var listItem = "_ih-2";
export var listItemWrapper = "_ih-1";
export var operationText = "_ih-3";